// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"profiler","293":"component---src-pages-index-js","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"7a8b646c340f70e0ce2c","293":"7153b2e62a9593de3b25","452":"e0239ebc16ecec20e6f8","522":"e9fb79faa67234c9ad5b","551":"c445dae029e747cff17f","777":"83392703a00277f43db3"}[chunkId] + ".js";
};